<div class="col-12 pt-3 d-flex justify-content-between movable"
     cdkDrag
     cdkDragRootElement=".cdk-overlay-pane"
     cdkDragHandle>
    <h5 class="table-title">Renewal Offer</h5>
    <a class="close cursor-pointer" aria-label="Close" [mat-dialog-close]="true">
        <span aria-hidden="true">&times;</span>
    </a>
</div>
<hr class="mt-1">
<mat-dialog-content class="renewal-modal pt-0">
    <div class="d-md-flex" *ngIf="data?.selectedPolicyRenewalTerm">
        <div class="col-md-7 col-12 pt-3">
            <div class="">
                <div class="renewal-offer-details pb-2 no-gutters">
                    <div class="row mb-1">
                        <div class="col-lg-5 col-7 font-weight-bold">Renewal Effective Date:</div>
                        <div class="col-lg-7 col-5">{{ data?.selectedPolicyRenewalTerm?.effectiveDate | date: 'mediumDate' | uppercase }}
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-lg-5 col-7 font-weight-bold">Renewal Expiration Date:</div>
                        <div class="col-lg-7 col-5">{{ data?.selectedPolicyRenewalTerm?.expirationDate | date: 'mediumDate' | uppercase }}
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-lg-5 col-7 font-weight-bold">Renewal Annual Premium:</div>
                        <div class="col-lg-7 col-5"> {{
                                data?.selectedPolicyRenewalTerm?.billing?.totalPremium |
                                    currency:'USD':'symbol-narrow':'1.2-2'
                            }}
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-lg-5 col-7 font-weight-bold">Renewal Premium Due:</div>
                        <div class="col-lg-7 col-5"> {{
                                data?.selectedPolicyRenewalTerm?.billing?.amountDue |
                                    currency:'USD':'symbol-narrow':'1.2-2'
                            }}
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-lg-5 col-7 font-weight-bold">Billing Address:</div>
                        <div class="col-lg-7 col-5">{{ data?.selectedPolicyRenewalTerm?.billing?.billingAddress?.formattedAddress }}
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-lg-5 col-7 font-weight-bold">Lienholder:</div>
                        <div class="col-lg-7 col-5">
                            <ul *ngFor="let lienholder of data?.selectedPolicyRenewalTerm?.lienholders"
                                class="list-unstyled">
                                <li>{{ lienholder?.name }}<br/>
                                    {{ lienholder?.address?.formattedAddress }}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- SCENARIO 1 -->
                    <ng-container
                            *ngIf="data?.selectedPolicyRenewalTerm?.billing?.paymentPlan?.paymentPlanType === 'PAPER' || data?.selectedPolicyRenewalTerm?.billing?.paymentPlan?.paymentPlanType === 'PAPER'">
                        <div class="row mb-1"
                             *ngIf="data?.selectedPolicyRenewalTerm?.billing?.paymentPlan?.paymentPlanType === 'PAPER'">
                            <div class="col-lg-5 col-7 font-weight-bold">Renewal Payment Plan:</div>
                            <div class="col-lg-7 col-5 primary-textcolor">
                                <strong *ngIf="data?.selectedPolicyRenewalTerm?.billing?.paymentPlan?.description"
                                        class="pr-3">
                                    {{ data?.selectedPolicyRenewalTerm?.billing?.paymentPlan?.description }}
                                </strong>
                            </div>
                        </div>
                    </ng-container>
                    <!--SCENARIO 1 Ends -->

                    <!-- SCENARIO - 2 -->
                    <ng-container
                            *ngIf="data?.selectedPolicyRenewalTerm?.billing?.paymentPlan?.paymentPlanType === 'AUTO' || data?.selectedPolicyRenewalTerm?.billing?.paymentPlan?.paymentPlanType === 'AUTO'">
                        <div class="row mb-1"
                             *ngIf="data?.selectedPolicyRenewalTerm?.billing?.paymentPlan?.paymentPlanType === 'AUTO'">
                            <div class="col-lg-5 col-7 font-weight-bold">Renewal Automatic payments:</div>
                            <div class="col-lg-7 col-5 primary-textcolor">
                                <strong *ngIf="data?.selectedPolicyRenewalTerm?.billing?.paymentPlan?.description"
                                        class="pr-3">
                                    {{ data?.selectedPolicyRenewalTerm?.billing?.paymentPlan?.description }}
                                </strong>
                            </div>
                        </div>
                    </ng-container>
                    <!-- SCENARIO 2 ENDS -->
                    <div class="mb-1 mt-3 font-weight-bold">Your current term will expire
                        on {{ data?.policyData?.terms[1]?.expirationDate | date: 'mediumDate' }}
                    </div>
                    <div class="mb-2 font-weight-bold">To renew your policy, please
                        pay {{ data?.renewalAmount | currency:'USD':'symbol-narrow':'1.2-2' }}
                    </div>
                    <div *ngIf="data?.policyData?.billing?.canMakeOneTimePayment">
                        <button routerLink="/policy-dashboard/{{data.policyData.policyNumber}}/payment/make-payment"
                                (click)="discard()"
                                class="btn btn-primary renewal-offer-details col-6">Renew My Policy
                        </button>
                    </div>
                    <div *ngIf="!data?.policyData?.billing?.canMakeOneTimePayment">
                        <a href="https://www.thig.com/contact/" target="_blank">Contact Us
                        </a> to renew this policy
                    </div>
                </div>
            </div>
        </div>
        <div class="renewal-coverage-details col-md-5 col-12 pt-md-0 pt-3" id="sub-time-line">
            <div id="property-coverage" class="flex-column d-md-flex">
                <h5 class="mb-2 mt-3" *ngIf="data?.policyData.lobType!='Flood'">Section I - Property Coverage
                    Limits</h5>
                <h5 class="mb-2 mt-3" *ngIf="data?.policyData.lobType=='Flood'">Flood Coverage Limits</h5>
                <p id="coverageA" *ngIf="data?.selectedPolicyRenewalTerm.coverageLabels.coverageA != null"
                   class="row mb-1">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold">{{ data?.selectedPolicyRenewalTerm.coverageLabels.coverageA.label }}
                        :</span>
                    <span class="col-lg-4 col-md-3 col-3" *ngIf="data?.policyData.lobType!='Flood'">
            {{ data?.selectedPolicyRenewalTerm.coverages.coverageA | currency:'USD':'symbol-narrow':'1.0-0' }}
          </span>
                    <span class="col-lg-4 col-md-3 col-3" *ngIf="data?.policyData.lobType=='Flood'">
            {{ data?.selectedPolicyRenewalTerm.coverages.floodBuildingLimit | currency:'USD':'symbol-narrow':'1.0-0' }}
          </span>
                </p>

                <p id="coverageB" class="row mb-1">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold" *ngIf="data?.selectedPolicyRenewalTerm.coverageLabels.coverageB != null">
                        {{data?.selectedPolicyRenewalTerm.coverageLabels.coverageB.label}}:
                    </span>
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold" *ngIf="data?.selectedPolicyRenewalTerm.coverageLabels.floodContentsLimit != null">
                        {{data?.selectedPolicyRenewalTerm.coverageLabels.floodContentsLimit.label}}:
                    </span>
                    <span class="col-lg-4 col-md-3 col-3" *ngIf="data?.policyData.lobType!='Flood'">
            {{ data?.selectedPolicyRenewalTerm.coverages.coverageB | currency:'USD':'symbol-narrow':'1.0-0' }}
          </span>
                    <span class="col-lg-4 col-md-3 col-3" *ngIf="data?.policyData.lobType=='Flood'">
            {{ data?.selectedPolicyRenewalTerm.coverages.floodContentsLimit | currency:'USD':'symbol-narrow':'1.0-0' }}
          </span>
                </p>

                <p id="coverageC" class="row mb-1" *ngIf="data?.selectedPolicyRenewalTerm.coverageLabels.coverageC != null">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold">{{data?.selectedPolicyRenewalTerm.coverageLabels.coverageC.label}}:</span>
                    <span class="col-lg-4 col-md-3 col-3">
            {{ data?.selectedPolicyRenewalTerm.coverages.coverageC | currency:'USD':'symbol-narrow':'1.0-0' }}
          </span>
                </p>

                <p class="row mb-1" id="coverageD">
          <span class="col-lg-8 col-md-9 col-9 font-weight-bold" *ngIf="data?.selectedPolicyRenewalTerm.coverageLabels.coverageD != null">
            {{data?.selectedPolicyRenewalTerm.coverageLabels.coverageD.label}}:
          </span>
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold" *ngIf="data?.selectedPolicyRenewalTerm.coverageLabels.floodIncrCostComplianceLimit != null">
            {{data?.selectedPolicyRenewalTerm.coverageLabels.floodIncrCostComplianceLimit.label}}:
          </span>
                    <span class="col-lg-4 col-md-3 col-3"
                          *ngIf="data?.policyData.lobType=='Mobile Home' && data?.policyData.address.administrativeArea == 'NC'">
            {{ data?.selectedPolicyRenewalTerm.coverages.coverageD | currency:'USD':'symbol-narrow':'1.0-0' }} per day (60 Day Max)
          </span>
                    <span class="col-lg-4 col-md-3 col-3"
                          *ngIf="data?.policyData.lobType!='Flood' && !(data?.policyData.address.administrativeArea == 'NC' && data?.policyData.lobType=='Mobile Home')">
            {{ data?.selectedPolicyRenewalTerm.coverages.coverageD | currency:'USD':'symbol-narrow':'1.0-0' }}
          </span>
                    <span class="col-lg-4 col-md-3 col-3" *ngIf="data?.policyData.lobType=='Flood'">
            {{ data?.selectedPolicyRenewalTerm.coverages.floodIncrCostComplianceLimit | currency:'USD':'symbol-narrow':'1.0-0' }}
          </span>
                </p>

                <p *ngIf="data?.policyData.lobType=='Flood'" class="row mb-1" id="coverageE">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold">{{data?.selectedPolicyRenewalTerm.coverageLabels.coverageE.label}}:</span>
                    <span class="col-lg-4 col-md-3 col-3">{{
                            data?.selectedPolicyRenewalTerm.coverages.floodLossOfUseLimit |
                                currency:'USD':'symbol-narrow':'1.0-0'
                        }}
          </span>
                </p>
            </div>
            <div id="liability-coverage" class="flex-column d-flex" *ngIf="data?.policyData.lobType!='Flood'">
                <h5 class="mb-2 mt-3">Section II - Liability Coverage Limits</h5>

                <p *ngIf="data?.policyData.lobType!='DwellingFire' && data?.selectedPolicyRenewalTerm.coverages.coverageE > 0"
                   class="row mb-1" id="personalLiability">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold">{{data?.selectedPolicyRenewalTerm.coverageLabels.coverageE.label}}:</span>
                    <span class="col-lg-4 col-md-3 col-3">{{
                            data?.selectedPolicyRenewalTerm.coverages.coverageE |
                                currency:'USD':'symbol-narrow':'1.0-0'
                        }}
          </span>
                </p>

                <p *ngIf="data?.policyData.lobType!='DwellingFire' && data?.selectedPolicyRenewalTerm.coverages.coverageF > 0"
                   class="row mb-1" id="coverageF">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold">{{data?.selectedPolicyRenewalTerm.coverageLabels.coverageF.label}}:</span>
                    <span class="col-lg-4 col-md-3 col-3">{{
                            data?.selectedPolicyRenewalTerm.coverages.coverageF |
                                currency:'USD':'symbol-narrow':'1.0-0'
                        }}
          </span>
                </p>
                <p id="coverageL" class="row mb-1" *ngIf="data?.selectedPolicyRenewalTerm.coverages.coverageL!=0">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold d-md-block d-none">{{data?.selectedPolicyRenewalTerm.coverageLabels.coverageL.label}}:</span>
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold d-md-none"> </span>
                    <span class="col-lg-4 col-md-3 col-3">{{
                            data?.selectedPolicyRenewalTerm.coverages.coverageL |
                                currency:'USD':'symbol-narrow':'1.0-0'
                        }}
          </span>
                </p>
                <p id="coverageM" class="row mb-1" *ngIf="data?.selectedPolicyRenewalTerm.coverages.coverageM!=0">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold d-md-block d-none">{{data?.selectedPolicyRenewalTerm.coverageLabels.coverageM.label}}:</span>
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold d-md-none">Coverage M </span>
                    <span class="col-lg-4 col-md-3 col-3">{{
                            data?.selectedPolicyRenewalTerm.coverages.coverageM |
                                currency:'USD':'symbol-narrow':'1.0-0'
                        }}
          </span>
                </p>
            </div>
            <div id="deductibles" class="flex-column d-flex">
                <h5 class="mb-2 mt-3">Deductibles</h5>
                <p id="others" class="row mb-1" *ngIf="data?.policyData.lobType!='Flood'">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold"> All Other Perils Deductible</span>
                    <span class="col-lg-4 col-md-3 col-3">{{
                            data?.selectedPolicyRenewalTerm.coverages.allOtherPerilsDeductible |
                                currency:'USD':'symbol-narrow':'1.0-0'
                        }}
          </span>
                </p>
                <p id="cyberShield-plus-deductible" class="row mb-1"
                   *ngIf="data?.selectedPolicyRenewalTerm.coverages?.cyberShieldPlusDeductible">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold"> CyberShield Plus:</span>
                    <span class="col-lg-4 col-md-3 col">{{
                            data?.selectedPolicyRenewalTerm.coverages.cyberShieldPlusDeductible |
                                currency:'USD':'symbol-narrow':'1.0-0'
                        }}
          </span>
                </p>
                <p id="hurricane" class="row mb-1"
                   *ngIf="data?.policyData.lobType!='Flood' && data?.selectedPolicyRenewalTerm.coverages?.hurricaneDeductible">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold">{{ data?.selectedPolicyRenewalTerm.coverages.hurricaneDeductibleLabel }}</span>
                    <span class="col-lg-4 col-md-3 col-3">{{
                            isNumber(data?.selectedPolicyRenewalTerm.coverages.hurricaneDeductible) ?
                            (data?.selectedPolicyRenewalTerm.coverages.hurricaneDeductible | currency:'USD':'symbol-narrow':'1.0-0')
                                                                                                    :
                            data?.selectedPolicyRenewalTerm.coverages.hurricaneDeductible
                        }}
          </span>
                </p>
                <p id="sinkhole" class="row mb-1" *ngIf="data?.selectedPolicyRenewalTerm.coverages?.sinkholeDeductible">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold"> Sinkhole Deductible:</span>
                    <span class="col-lg-4 col-md-3 col-3">{{
                            isNumber(data?.selectedPolicyRenewalTerm.coverages.sinkholeDeductible) ?
                            (data?.selectedPolicyRenewalTerm.coverages.sinkholeDeductible | currency:'USD':'symbol-narrow':'1.0-0')
                                                                                                   :
                            data?.selectedPolicyRenewalTerm.coverages.sinkholeDeductible
                        }}
          </span>
                </p>
                <p *ngIf="data?.selectedPolicyRenewalTerm.coverages?.floodDeductible>0" class="row mb-1" id="flood">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold"> Flood Deductible:</span>
                    <span class="col-lg-4 col-md-3 col-3">{{
                            data?.selectedPolicyRenewalTerm.coverages?.floodDeductible |
                                currency:'USD':'symbol-narrow':'1.0-0'
                        }}
          </span>
                </p>
                <p *ngIf="data?.selectedPolicyRenewalTerm.coverages?.equipmentBreakDownDeductible>0" class="row mb-1"
                   id="equipmentBreakdown">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold"> Equipment Breakdown Deductible:</span>
                    <span class="col-lg-4 col-md-3 col-3">{{
                            data?.selectedPolicyRenewalTerm.coverages?.equipmentBreakDownDeductible |
                                currency:'USD':'symbol-narrow':'1.0-0'
                        }}
          </span>
                </p>
                <p *ngIf="data?.selectedPolicyRenewalTerm.coverages?.serviceLineDeductible>0" class="row mb-1"
                   id="serviceLine">
                    <span class="col-lg-8 col-md-9 col-9 font-weight-bold"> Service Line Deductible:</span>
                    <span class="col-lg-4 col-md-3 col-3">{{
                            data?.selectedPolicyRenewalTerm.coverages?.serviceLineDeductible |
                                currency:'USD':'symbol-narrow':'1.0-0'
                        }}
          </span>
                </p>
            </div>
        </div>
    </div>
</mat-dialog-content>
